module.exports = __webpack_public_path__ + "img/img11.e15f2168.jpg";